import "./UnAuthHeaderComponent.scss";
import {ImageConfig} from "@/constants";
import {Button} from "@/components/ui/button.tsx";
import {UserRoundCheckIcon, Rocket} from "lucide-react";
import {ReactNode} from "react";
import {Outlet, useNavigate} from "react-router-dom";
import {DEFAULT_ROUTE, PROJECTS_ROUTE} from "@/constants/RoutesConfig.tsx";
import { useIsMobile } from "@/hooks/use-mobile";

const UnAuthHeaderComponent = () => {

    const navigate =  useNavigate();
    const isMobile = useIsMobile();

    return (
        <div className={'un-auth-header-component'}>
            <div className="app-header fixed top-0 left-0 right-0 bg-background z-50 border-b">
                {/* Header */}
                <header className="flex flex-col justify-between h-full">
                    <div className="flex justify-between items-center px-4 h-full">
                        <div className={'flex ts-align-items-center hover:cursor-pointer'} onClick={()=>navigate(DEFAULT_ROUTE)}>
                        {isMobile ? (
                            <ImageConfig.LogoSmallIcon className="h-8 w-8" />
                        ) : (
                            <ImageConfig.MediumLogo/>
                        )}
                            {/*<SidebarTrigger onClick={() => setIsCollapsed(!isCollapsed)}/>*/}
                        </div>
                        <div className={'header-right-wrapper flex items-center gap-3'}>
                            <Button
                                variant={'default'}
                                size={"header"}
                                prefixIcon={<Rocket className={"small"} size={14}/> as ReactNode}
                                onClick={() => navigate(PROJECTS_ROUTE)}
                            >
                                
                                Get Started
                            </Button>
                            <Button
                                variant={'outline'}
                                size={"header"}
                                prefixIcon={<UserRoundCheckIcon className={"small"} size={14}/> as ReactNode}
                                onClick={() => {
                                    window.location.href = `mailto:info@superengineer.ai?subject=Enterprise Plan Inquiry&body=Hi, I'm interested in learning more about the Enterprise Plan.`;
                                }}
                            >
                               Support
                            </Button>
                            {/*<div className={'vertical-separator'}/>*/}
                            {/*<HeaderUserIconComponent/>*/}
                        </div>
                    </div>
                </header>
            </div>
            <div className="pt-[60px] w-full  min-h-[calc(100vh - 70px)] overflow-auto"> {/* Add padding-top to account for fixed header */}
                <Outlet/>
            </div>

        </div>
    );

};

export default UnAuthHeaderComponent;
